<script lang="ts">
	interface Props {
		multiple?: boolean
		right?: boolean
		children?: import('svelte').Snippet
	}

	let { multiple = false, right = false, children }: Props = $props()
</script>

<div
	class="
    border-primary-500 absolute top-full mt-2 w-[calc(100vw_-_24px)] max-w-sm rounded-lg border bg-white shadow-md dark:bg-gray-800
    {right ? 'right-0' : 'left-0'}
    {multiple ? 'sm:max-w-[40rem] xl:max-w-3xl' : ''}
  "
>
	{@render children?.()}
</div>
